/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'hr',
  Pagination: {
    items_per_page: '/ str',
    jump_to: 'Idi na',
    jump_to_confirm: 'potvrdi',
    page: '',
    prev_page: 'Prijašnja stranica',
    next_page: 'Sljedeća stranica',
    prev_5: 'Prijašnjih 5 stranica',
    next_5: 'Sljedećih 5 stranica',
    prev_3: 'Prijašnje 3 stranice',
    next_3: 'Sljedeće 3 stranice'
  },
  DatePicker: {
    lang: {
      placeholder: 'Odaberite datum',
      rangePlaceholder: ['Početni datum', 'Završni datum'],
      locale: 'hr_HR',
      today: 'Danas',
      now: 'Sad',
      backToToday: 'Natrag na danas',
      ok: 'Ok',
      clear: 'Očisti',
      month: 'Mjesec',
      year: 'Godina',
      timeSelect: 'odaberite vrijeme',
      dateSelect: 'odaberite datum',
      weekSelect: 'Odaberite tjedan',
      monthSelect: 'Odaberite mjesec',
      yearSelect: 'Odaberite godinu',
      decadeSelect: 'Odaberite desetljeće',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prošli mjesec (PageUp)',
      nextMonth: 'Sljedeći mjesec (PageDown)',
      previousYear: 'Prošla godina (Control + left)',
      nextYear: 'Sljedeća godina (Control + right)',
      previousDecade: 'Prošlo desetljeće',
      nextDecade: 'Sljedeće desetljeće',
      previousCentury: 'Prošlo stoljeće',
      nextCentury: 'Sljedeće stoljeće'
    },
    timePickerLocale: {
      placeholder: 'Odaberite vrijeme'
    }
  },
  TimePicker: {
    placeholder: 'Odaberite vrijeme'
  },
  Calendar: {
    lang: {
      placeholder: 'Odaberite datum',
      rangePlaceholder: ['Početni datum', 'Završni datum'],
      locale: 'hr_HR',
      today: 'Danas',
      now: 'Sad',
      backToToday: 'Natrag na danas',
      ok: 'Ok',
      clear: 'Očisti',
      month: 'Mjesec',
      year: 'Godina',
      timeSelect: 'odaberite vrijeme',
      dateSelect: 'odaberite datum',
      weekSelect: 'Odaberite tjedan',
      monthSelect: 'Odaberite mjesec',
      yearSelect: 'Odaberite godinu',
      decadeSelect: 'Odaberite desetljeće',
      yearFormat: 'YYYY',
      dateFormat: 'D.M.YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D.M.YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Prošli mjesec (PageUp)',
      nextMonth: 'Sljedeći mjesec (PageDown)',
      previousYear: 'Prošla godina (Control + left)',
      nextYear: 'Sljedeća godina (Control + right)',
      previousDecade: 'Prošlo desetljeće',
      nextDecade: 'Sljedeće desetljeće',
      previousCentury: 'Prošlo stoljeće',
      nextCentury: 'Sljedeće stoljeće'
    },
    timePickerLocale: {
      placeholder: 'Odaberite vrijeme'
    }
  },
  global: {
    placeholder: 'Molimo označite'
  },
  Table: {
    filterTitle: 'Filter meni',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Označi trenutnu stranicu',
    selectInvert: 'Invertiraj trenutnu stranicu',
    sortTitle: 'Sortiraj'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Odustani',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Odustani'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Pretraži ovdje',
    itemUnit: 'stavka',
    itemsUnit: 'stavke'
  },
  Upload: {
    uploading: 'Upload u tijeku...',
    removeFile: 'Makni datoteku',
    uploadError: 'Greška kod uploada',
    previewFile: 'Pogledaj datoteku',
    downloadFile: 'Preuzmi datoteku'
  },
  Empty: {
    description: 'Nema podataka'
  },
  Icon: {
    icon: 'ikona'
  },
  Text: {
    edit: 'uredi',
    copy: 'kopiraj',
    copied: 'kopiranje uspješno',
    expand: 'proširi'
  }
};
